var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-search",attrs:{"color":"#3C8DBC","disabled":_vm.disabled},on:{"click":_vm.callback}},[_vm._v(" Search ")])
}
var staticRenderFns = []

export { render, staticRenderFns }